export const columns = [
  {
    Header: '#',
    accessor: 'id',
  },
  {
    Header: 'Invoice ID',
    accessor: 'invoice_id',
  },
  {
    Header: 'Customer',
    accessor: 'user_id'
  },
  {
    Header: 'Project',
    accessor: 'project_id'
  },
  {
    Header: 'Subtotal',
    accessor: 'subtotal',
  },
  {
    Header: 'Discount',
    accessor: 'discount',
  },
  {
    Header: 'Total',
    accessor: 'total',
  },
  {
    Header: 'Currency',
    accessor: 'currency',
  },
  {
    Header: 'Created Date',
    accessor: 'date_created',
  },
  {
    Header: 'Send Date',
    accessor: 'date_start',
  },
  {
    Header: 'Paid Date',
    accessor: 'date_end',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Action',
    accessor: 'action',
    disableGlobalFilter: true,
    disableSortBy: true,
  },
];